import { Button, Input, Select, Stack, Textarea } from "@chakra-ui/react";


export default function BusinessDetails() {
    return (
        <>
            <Stack
                direction={'row'}
                w={'full'}
                justify={'space-between'}
                spacing={4}
            >
                <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Business Name' />

                <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Business Short Name' />

                <Select placeholder='Industry' w={'100%'}>
                    <option value='option1'>Fashion Industry</option>
                    <option value='option2'>IT Industry</option>
                    <option value='option2'>Real Estate Industry</option>
                    <option value='option2'>Others</option>
                </Select>
            </Stack>

            <Stack
                direction={'row'}
                w={'full'}
                justify={'space-between'}
                spacing={4}
            >
                <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Document Inbox' />

                <Select placeholder='Business Type' w={'100%'}>
                    <option value='option1'>Non Profit Organization</option>
                    <option value='option2'>Limited Company</option>
                </Select>

                <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Registration Number' />
            </Stack>

            <Stack
                direction={'row'}
                w={'full'}
                justify={'space-between'}
                spacing={4}
            >
                <Select placeholder='Country' w={'100%'}>
                    <option value='option1'>UK</option>
                    <option value='option2'>USA</option>
                    <option value='option2'>IRE</option>
                    <option value='option2'>PK</option>
                    <option value='option2'>IN</option>
                    <option value='option2'>THL</option>
                    <option value='option2'>AUS</option>
                    <option value='option2'>AUS</option>
                    <option value='option2'>UAE</option>
                    <option value='option2'>SA</option>
                    <option value='option2'>SL</option>
                </Select>

                <Select placeholder='Base Currency' w={'100%'}>
                    <option value='option1'>Karachi / Sindh</option>
                    <option value='option2'>Sukkur / Sindh</option>
                    <option value='option2'>Jamshoro / Sindh</option>
                    <option value='option2'>Multan / Punjab</option>
                    <option value='option2'>Lahore / Punjab</option>
                    <option value='option2'>Islamabad / Punjab</option>
                    <option value='option2'>Peshawar / KPK</option>
                </Select>

                <Select placeholder='Base Currency' w={'100%'}>
                    <option value='option1'>GBP Great Britain Pound</option>
                    <option value='option2'>USD United States Dollar</option>
                    <option value='option2'>CAD Canadian Dollar</option>
                    <option value='option2'>IEP Irish Pound</option>
                    <option value='option2'>EUR German Euro</option>
                </Select>
            </Stack>

            <Stack
                direction={'row'}
                w={'full'}
                justify={'space-between'}
                spacing={4}
            >
                <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Postal Code' />

                <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Contact Number' />

                <Input type='text' size={'md'} w={'100%'} fontSize={'md'} placeholder='Website' />
            </Stack>

            <Stack
                direction={'row'}
                w={'full'}
                justify={'space-between'}
                spacing={4}
            >
                <Textarea
                    w={'100%'}
                    h={'100px'}
                    resize={'none'}
                    placeholder={"Address"}
                >
                </Textarea>
            </Stack>
            <Button colorScheme={'primary'}>Save</Button>
        </>
    )
}